interface CategorizationScheme {
  id: number;
  name: string;
  type: string;
}

/**
 * Returns the name of the category scheme that matches the provided ID.
 *
 * @param categorySchemeId - The ID of the category scheme to find.
 * @param schemes - Array of category schemes to search.
 * @returns The name of the matching category scheme, or undefined if not found.
 */
export function getCategorySchemeNameById(
  categorySchemeId: number,
  schemes: CategorizationScheme[],
): string | undefined {
  return schemes.find((scheme) => scheme.id === categorySchemeId)?.name;
}
